import Title from "components/common/Title";
import { LockGateContext } from "components/Gates/LockGate";
import React, { FunctionComponent, useContext, useEffect } from "react";
import { Col, Row } from "react-grid-system";
import { Routes } from "router";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import strings from "static/strings.js";
import { StyledButton, StyledContent, StyledHeader } from "./Welcome.style";

const Welcome: FunctionComponent = () => {
  const { goTo } = OnboardingContainer.useContainer();

  const handleOnDone = (event?: React.SyntheticEvent<HTMLButtonElement>) => {
    goTo({ route: Routes.Home, clearSession: true });
  };
  return (
    <div>
      <StyledHeader>
        <Row>
          <Col>Thank You for Signing Up at this new location</Col>
        </Row>
      </StyledHeader>
      <StyledContent noBackground>
        <Title>{strings.kioskWelcome}</Title>
        <StyledButton primary onClick={handleOnDone}>
          Done
        </StyledButton>
      </StyledContent>
    </div>
  );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/screens/Kiosk/WelcomeToLocation.tsx